import React from 'react';

import { StepSelectControlOptionWithIconProps } from './StepSelectControlOptionWithIcon.interface';
import { useStyles } from './StepSelectControlOptionWithIcon.styles';

export default function StepSelectControlOptionWithIcon({
  icon,
  label,
}: StepSelectControlOptionWithIconProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {icon}
      <div className={classes.label} aria-label={label}>
        {label}
      </div>
    </div>
  );
}
